/**
 * Stub of RNWatch for Android.
 *
 * @providesModule RNWatch
 */
'use strict';

export const useInstalled = () => false;
export const usePaired = () => false;
export const useReachability = () => false;
export const useApplicationContext = () => false;
